


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'VAvatar'
})
export default class VAvatar extends Vue {
  @Prop({ required: true }) username?: string;
  @Prop({ required: true }) picture?: string;
  @Prop({ required: false }) status?: string;
  @Prop({ required: false }) size?: { width: number; height: number };

  get style() {
    let style = 'height:' + (this.size?.height || 3) + 'rem;';
    if (!this.picture) {
      style += 'border-radius: 50%; width: ' + (this.size?.width || 3) + 'rem;';
    }
    return style;
  }

  get textSize() {
    return 'font-size: ' + (this.size?.width || 3) * 0.5 + 'rem;';
  }

  get shortUsername() {
    return (this.username || 'TE')
      .match(/\b(\w)/g)
      ?.join('')
      .substr(0, 2);
  }
}
